export const prepareSeparatorElements = (htmlValue: Document) => {
  const divElements = htmlValue.querySelectorAll('div')

  divElements.forEach((divElement) => {
    const separatorClasses = divElement.getAttribute('class')
    if (separatorClasses && separatorClasses.split(' ').indexOf('separator') !== -1) {
      const separatorElement = document.createElement('hr')
      separatorElement.style.width = '100%'

      const separatorColor = separatorClasses.match(/separator-bg-(\w+)/)
      if (separatorColor) {
        separatorElement.style.backgroundColor = `#${separatorColor[1]}`
      }
      const separatorHeight = separatorClasses.match(/separator-thickness-(\w+)/)
      if (separatorHeight) {
        separatorElement.style.height = `${separatorHeight[1]}px`
      }
      divElement.replaceWith(separatorElement)
    }
  })
}
